import {API} from "../../constAPI";

const jsonHeaders = {
  Accept: "application/json",
  "Content-type": "application/json",
};

export const getRestringingVendors = (token) => {
  return fetch(`${API}/api/admin/restringing/vendors`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getRestringingVendor = (vendorId, token) => {
  return fetch(`${API}/api/admin/restringing/vendors/${vendorId}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const upsertRestringingVendor = (payload, token) => {
  return fetch(`${API}/api/admin/restringing/vendors`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateRestringingVendor = (vendorId, changes, token) => {
  return fetch(`${API}/api/admin/restringing/vendors/${vendorId}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getRestringingVendorImageUpload = ({vendorId, fileType, token}) => {
  const params = new URLSearchParams({file_type: fileType});
  if (vendorId) params.set("id", vendorId);

  return fetch(`${API}/api/admin/restringing/vendors/image-upload?${params.toString()}`, {
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const deleteRestringingVendor = (vendorId, token) => {
  return fetch(`${API}/api/admin/restringing/vendors/${vendorId}`, {
    method: "DELETE",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getRestringingOrders = (token, filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();

  return fetch(`${API}/api/admin/restringing/orders${query ? `?${query}` : ""}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getDeferredPayouts = (token, filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();

  return fetch(`${API}/api/admin/restringing/deferred-payouts${query ? `?${query}` : ""}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getRestringingOrder = (orderId, token) => {
  return fetch(`${API}/api/admin/restringing/orders/${orderId}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const retryRestringingTransfers = ({orderId, limit = 1} = {}, token) => {
  const payload = {
    limit,
  };
  if (orderId) payload.order_id = Number(orderId);

  return fetch(`${API}/api/admin/restringing/orders/retry-transfers`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getRestringingServiceTiers = (token) => {
  return fetch(`${API}/api/admin/restringing/service-tiers`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateRestringingServiceTier = (tierId, changes, token) => {
  return fetch(`${API}/api/admin/restringing/service-tiers/${tierId}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const upsertRestringingServiceTier = (payload, token) => {
  return fetch(`${API}/api/admin/restringing/service-tiers`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getRestringingRecommendationCategories = (token) => {
  return fetch(`${API}/api/admin/restringing/recommendation-categories`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const upsertRestringingRecommendationCategory = (payload, token) => {
  return fetch(`${API}/api/admin/restringing/recommendation-categories`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateRestringingRecommendationCategory = (category, changes, token) => {
  return fetch(`${API}/api/admin/restringing/recommendation-categories/${category}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const deleteRestringingRecommendationCategory = (category, token) => {
  return fetch(`${API}/api/admin/restringing/recommendation-categories/${category}`, {
    method: "DELETE",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getRestringingStrings = (token) => {
  return fetch(`${API}/api/admin/restringing/strings`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const upsertRestringingString = (payload, token) => {
  return fetch(`${API}/api/admin/restringing/strings`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateRestringingString = (stringId, changes, token) => {
  return fetch(`${API}/api/admin/restringing/strings/${stringId}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const signupVendorStaff = ({email, password}) => {
  return fetch(`${API}/api/auth/signup`, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({
      email,
      password,
      user_type: 4,
    }),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const assignVendorStaff = ({vendorId, userId, role, token}) => {
  return fetch(`${API}/api/admin/restringing/vendors/${vendorId}/staff/${userId}`, {
    method: "PUT",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify({
      role,
      active: true,
    }),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};
